import {useRef,useMemo} from "react";
import DeliveryPricingRuleCityPopup from './DeliveryPricingRuleCityPopup.js';
import COMPONENT_MAP from '../Repository/Components.js';

const DeliveryPricingRuleCities=({parentId,application,userData,parent})=>{
    const list_name='delivery_pricing_rule_cities';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'DeliveryPricingCity'}
                entityParams={['delivery_pricing_rule_id='+parentId,'_context='+['parent_name=DeliveryPricingRule'],'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'DeliveryPricingRuleCities.js'}
                navigateOnNew={null}
                initialState={{}}
                checkboxSelection={true}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                popupComponent={DeliveryPricingRuleCityPopup}
                parentContext={{
                    parent_field_name:'delivery_pricing_rule_id',
                    parent_field_value:null,
                    parent_name:'DeliveryPricingRule',
                }}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return(renderListTab);
}
export default DeliveryPricingRuleCities;